/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthLoginResponseDto } from '../../models/auth-login-response-dto';
import { ChangePasswordDto } from '../../models/change-password-dto';

export interface AuthControllerChangePassword$Params {
      body: ChangePasswordDto
}

export function authControllerChangePassword(http: HttpClient, rootUrl: string, params: AuthControllerChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthLoginResponseDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerChangePassword.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthLoginResponseDto>;
    })
  );
}

authControllerChangePassword.PATH = '/auth/change-password';
